import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { StaffPersonalDetailsPermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
  perm: string | readonly string[],
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Staff personal details page export "${exportName}" not found`)
  }
  return { Component: createPermissionGuardedPage(perm, Page) }
}

export const staffPersonalDetailsRoutes: RouteObject[] = [
  {
    path: 'hr/staff-personal-details',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/staff-personal-details-page'),
        'StaffPersonalDetailsPage',
        StaffPersonalDetailsPermissions.access,
      ),
  },
  {
    path: 'hr/staff-personal-details-import',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/staff-personal-details-import-page'),
        'StaffPersonalDetailsImportPage',
        StaffPersonalDetailsPermissions.importAccess,
      ),
  },
  {
    path: 'hr/staff-personal-details/:id',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/staff-personal-detail-page'),
        'StaffPersonalDetailPage',
        StaffPersonalDetailsPermissions.access,
      ),
  },
]
